module.exports = __webpack_public_path__ + "images/screen-shots/enrollment-c6a49f52129a75e1ca565bd23499625e.png";